import React from 'react'
import { Button } from 'antd';

const MainButton = ({ title, title2, disabled }) => {
  return (
    <>
      <div className="Button_div"> <Button disabled={disabled} className='Main_button'  >{title}</Button>
      </div>

    </>
  )
}

export default MainButton
